import { FieldState } from '@user/components/xGrid'
import { AppDispatch } from '../hooks/useAppDispatch'
import { EntityPreferenceType } from './typings'
import {
  setActivitySummaryColumnOrder,
  setDraftLeadColumnOrder,
  setGuestUserDashboardLeadsColumnOrder,
  setGuestUserDashboardOpportunitiesColumnOrder,
  setImportColumnOrder,
  setLeadColumnOrder,
  setOpportunityColumnOrder,
  setPestPacLocationColumnOrder,
  setRolesColumnOrder,
  setSCWebhooksColumnOrder,
  setUsersColumnOrder,
  setWorkWaveContactsColumnOrder,
} from './slice'
import { saveListViewPreference } from './api'

export function deserialize(json: string): FieldState[] {
  try {
    const parsed = JSON.parse(json)
    return parsed as FieldState[]
  } catch {
    return []
  }
}

export function getSaveListViewPreferenceFunc(type: EntityPreferenceType) {
  return (dispatch: AppDispatch, columnOrder: FieldState[]) => {
    switch (type) {
      case 'draft':
        dispatch(setDraftLeadColumnOrder(columnOrder))
        break
      case 'lead':
        dispatch(setLeadColumnOrder(columnOrder))
        break
      case 'opp':
        dispatch(setOpportunityColumnOrder(columnOrder))
        break
      case 'activitySummary':
        dispatch(setActivitySummaryColumnOrder(columnOrder))
        break
      case 'import':
        dispatch(setImportColumnOrder(columnOrder))
        break
      case 'users':
        dispatch(setUsersColumnOrder(columnOrder))
        break
      case 'scWebhooks':
        dispatch(setSCWebhooksColumnOrder(columnOrder))
        break
      case 'roles':
        dispatch(setRolesColumnOrder(columnOrder))
        break
      case 'workWaveContactDuplicates':
        dispatch(setWorkWaveContactsColumnOrder(columnOrder))
        break
      case 'pestPacLocationDuplicates':
        dispatch(setPestPacLocationColumnOrder(columnOrder))
        break
      case 'guestUserDashboard':
        dispatch(setGuestUserDashboardLeadsColumnOrder(columnOrder))
        break
      case 'guestUserDashboardLeads':
        dispatch(setGuestUserDashboardLeadsColumnOrder(columnOrder))
        break
      case 'guestUserDashboardOpportunities':
        dispatch(setGuestUserDashboardOpportunitiesColumnOrder(columnOrder))
        break
    }
    dispatch(
      saveListViewPreference({
        type,
        columnOrder: JSON.stringify(columnOrder),
      }),
    )
  }
}
